import type { LucideIcon } from 'lucide-react'

import { EmptyState } from '@/components/ui'

export interface ModuleEmptyPageProps {
  readonly icon: LucideIcon
  readonly title: string
  readonly description: string
}

/**
 * Pagina inteira para um modulo ainda nao implementado: empty state honesto (o que o modulo
 * vai fazer + que ainda nao esta disponivel), nunca dado falso nem funcionalidade fingida
 * (docs/design/01-PRODUCT-UX-PRINCIPLES.md secao 7).
 */
export function ModuleEmptyPage({ icon, title, description }: ModuleEmptyPageProps) {
  return (
    <div className="flex h-full items-center justify-center py-12">
      <EmptyState icon={icon} title={title} description={description} className="max-w-lg" />
    </div>
  )
}
